import React from 'react'
import './GetStarted.css'



const GetStarted = () => {
  return (
    <section className="g-wrapper">
        <div className="paddings innerWidth g-container">
            <div className="flexColCenter inner-container">
                <span className='primaryText'>Achieve results, not phases. ANDI</span>
                <span className='secondaryText'>The only thing we know about the future is that it will be different.<br/>
                        Realise your dreams soon.</span>
                <button className="button">
                    <a href="mailto:andiqorri3@gmail.com">DREAMS</a>
                </button>
            </div>
        </div>
    </section>
  )
}

export default GetStarted